<template>
  <!-- TODO: transition-groupがまともになったら共通コンポーネントに分ける -->
  <transition-group
    name="fade-in"
    tag="ul"
    class="alert-list"
  >
    <li
      v-for="alert in items"
      :key="alert.id"
      class="alert-list__item"
    >
      <alert-box
        v-bind="alert"
        @close="$emit('close', $event)"
      />
    </li>
  </transition-group>
</template>

<script>
import { alertListProps } from '@/mikan/_shared/lib/plugins/AlertBox/vueTypes';
import AlertBox from '@/mikan/_shared/components/molecules/AlertBox.vue';

export default {
  components: {
    AlertBox,
  },
  props: alertListProps,
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/pc/base/constants';

.alert-list {
  position: relative;
  background-color: $color-white;

  &__item {
    transition: opacity $transition-base, transform $transition-base;

    &:nth-child(n + 2) {
      margin-top: 2px;
    }
  }
}

.fade-in {
  &-enter,
  &-leave-to {
    opacity: 0;
    transform: translateY(-8%);
  }

  &-leave-active {
    position: absolute;
    width: 100%;
  }
}
</style>
